module.exports = require('@bugsnag/node')
